import type { AxiosResponse } from 'axios';

import api from '@/utils/axiosInterceptor';
import type { ApiResponse } from '@/utils/deepmerge';

import type {
  IIncomingInvoiceQuery,
  IIncomingInvoicesListResponse,
  IInvoiceDetails,
} from './IncomingInvoice.interface';

export async function GetInvoicesListInitialData(query: IIncomingInvoiceQuery) {
  const link = query?.invoiceId
    ? `/purchases-requests/incoming-invoices/?invoiceID=${query.invoiceId}&startDate=${query.startDate}&endDate=${query.endDate}`
    : query?.supplierId
      ? `/purchases-requests/incoming-invoices/?startDate=${query.startDate}&endDate=${query.endDate}&supplierID=${query.supplierId}`
      : `/purchases-requests/incoming-invoices/?startDate=${query.startDate}&endDate=${query.endDate}`;
  const response: AxiosResponse<ApiResponse<IIncomingInvoicesListResponse>> =
    await api.get(link);
  return response?.data;
}

export async function GetInvoiceDetails(invoiceId: number | null) {
  if (!invoiceId) return null;
  const response: AxiosResponse<ApiResponse<IInvoiceDetails>> = await api.get(
    `/purchases-requests/incoming-invoice/${invoiceId}`,
  );
  return response?.data;
}
